// Import ES6 Promise
import 'es6-promise/auto'

// Import global styles
// import '../static/css/imported/bootstrap.min.css'
import '../static/css/Custom.scss'
import 'vue-snotify/styles/material.css'
import 'vue-croppa/dist/vue-croppa.css'
import * as VueGoogleMaps from 'vue2-google-maps'
import Geocoder from '@pderas/vue2-geocoder'

// Import global js files
// import '../static/js/plugins/bootstrap/bootstrap.min'
// import 'jquery'

// Import System requirements
import Vue from 'vue'

import { sync } from 'vuex-router-sync'
import routes from './routes'
import store from './store'

import { httpClient, wsClient, authInterceptor, authService } from './services'

import axios from 'axios'
import qs from 'querystring'
import config, { resources } from './config'

// Import plugins
import VueRouter from 'vue-router'
import RestHapiRepository from './plugins/repository-plugin'
import Snotify, { SnotifyPosition } from 'vue-snotify'
import VueMoment from 'vue-moment'

// Import global components
import { ServerTable } from 'vue-tables-2'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import VueForm from 'vue-form'
import VueSelect from 'vue-select'
import VueModal from 'vue-js-modal'
import ToggleButton from 'vue-js-toggle-button'
import VuePassword from 'vue-password/dist/custom'
import VueMaskedInput from 'vue-masked-input'
import Croppa from 'vue-croppa'
import Carousel3d from 'vue-carousel-3d'
import VueGridLayout from 'vue-grid-layout'
import VTooltip from 'v-tooltip'
import Box from './components/utilities/Box.vue'
import VueFormInput from './components/utilities/VueFormInput.vue'

import DatePicker from 'vue2-datepicker'
import DateTimePicker from 'simple-vue2-datetimepicker'
import firebase from 'firebase'
import VueTimepicker from 'vue2-timepicker'
import { Datetime } from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
// import * as Msal from 'msal'

// import ChatBox from './components/utilities/ChatBox.vue'
// import NewGroupChat from './components/utilities/NewGroupChat.vue'
// import VueEditor from './components/utilities/VueEditor.vue'
// import VistorMap from './components/utilities/VisitorMap.vue'

// Import global directives
import vPermission from './directives/v-permission'

// Import Helpers for filters
import {
  domain,
  count,
  prettyDate,
  pluralize,
  shortMessage,
  userList
} from './filters'

// Import Views - Top level
import AppView from './components/App.vue'
import msal from 'vue-msal'
// import { authService } from './services'
// import moment from 'moment-timezone'
// moment.tz.setDefault('Asia/Kolkata')

// Import Install and register helper items
Vue.filter('count', count)
Vue.filter('domain', domain)
Vue.filter('prettyDate', prettyDate)
Vue.filter('pluralize', pluralize)
Vue.filter('shortMessage', shortMessage)
Vue.filter('userList', userList)

axios.defaults.baseURL = config.serverURI

// Replace default serializer with one that works with Joi validation
axios.defaults.paramsSerializer = function(params) {
  return qs.stringify(params)
}

// Register global components and plugins
Vue.component('box', Box)
Vue.component('vue-form-input', VueFormInput)
Vue.component('pulse-loader', PulseLoader)
Vue.component('vue-select', VueSelect)
Vue.component('vue-password', VuePassword)
Vue.component('vue-masked-input', VueMaskedInput)
Vue.component('grid-layout', VueGridLayout.GridLayout)
Vue.component('grid-item', VueGridLayout.GridItem)
Vue.component('date-picker', DatePicker)
Vue.component('datetimepicker', DateTimePicker)
Vue.component('vue-timepicker', VueTimepicker)
Vue.component('datetime', Datetime)

// Vue.component('chat-box', ChatBox)
// Vue.component('new-group-chat', NewGroupChat)
// Vue.component('vue-editor', VueEditor)
// Vue.component('visitor-map', VistorMap)

Vue.use(VueRouter)
Vue.use(RestHapiRepository, { httpClient, resources, log: true })
Vue.use(ServerTable, {}, false)
Vue.use(VueForm, {
  inputClasses: {
    valid: 'form-control-success',
    invalid: 'form-control-danger'
  }
})
Vue.use(Geocoder, {
  // defaultCountryCode: 'IN', // e.g. 'CA'
  defaultLanguage: 'en', // e.g. 'en'
  defaultMode: 'lat-lng', // or 'lat-lng'
  googleMapsApiKey: 'AIzaSyBvu5T76L9QqcebnQuUYUAAsdrI-DmvGK4'
})
Vue.use(Snotify, {
  toast: {
    position: SnotifyPosition.rightTop
  }
})
Vue.use(ToggleButton)
Vue.use(VueMoment)
Vue.use(VueModal)
Vue.use(Croppa)
Vue.use(Carousel3d)
Vue.use(VTooltip)
Vue.component('VueCtkDateTimePicker', VueCtkDateTimePicker)

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAbpjPvMo7ycCaYrT1mChG7sZsrcZgKJ-8',
    libraries: 'places',
    region: 'INDIA',
    language: 'English'
  }
})
Vue.directive('permission', vPermission)

// Routing logic
var router = new VueRouter({
  routes: routes,
  mode: 'history',
  linkExactActiveClass: 'active',
  scrollBehavior: function(to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 }
  }
})

// Some middleware to help us ensure the user is authenticated.
router.beforeEach((to, from, next) => {
  if (
    to.matched.some(record => record.meta.requiresAuth) &&
    (!router.app.$store.state.auth.accessToken ||
      router.app.$store.state.auth.accessToken === 'null')
  ) {
    // This route requires auth, check if logged in
    // if not, redirect to login page.
    window.console.log('Not authenticated')
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  } else {
    next()
  }
})

// Redirect authenticated users away from login views, etc.
router.beforeEach((to, from, next) => {
  if (
    to.matched.some(record => record.meta.requiresUnauth) &&
    router.app.$store.state.auth.accessToken
  ) {
    // Redirect authenticated users to the dashboard.
    window.console.log('Authenticated')
    next({
      path: '/'
    })
  } else {
    next()
  }
})

// Force users to update their password or PIN if needed.
// This mainly applies to users that have been invited to the system.
router.beforeEach((to, from, next) => {
  if (
    (store.state.auth.user.passwordUpdateRequired ||
      store.state.auth.user.pinUpdateRequired) &&
    to.fullPath !== '/profile?settings=true'
  ) {
    next({
      path: '/profile',
      query: { settings: true }
    })
  } else {
    next()
  }
})

// Manage breadcrumbs
router.beforeEach((to, from, next) => {
  store.dispatch('setBreadcrumbs', { currentPath: to.path })
  next()
})

sync(store, router)

// Set up websockets
// store.dispatch('websocket/init')
if (store.state.auth.accessToken) {
  wsClient.connect()
}

// Add a response interceptor
axios.interceptors.response.use(function(response) {
  return Promise.resolve(response)
}, authInterceptor.responseError)
axios.defaults.headers.common = {
  Accept: 'application/json',
  'Content-Type': 'application/json'
}
// Initialize auth header
axios.defaults.headers.common.Authorization =
  'Bearer ' + store.state.auth.accessToken

// Post to visitor endpoint to record visit
// statsService.postVisit()

// Start our app!
// eslint-disable-next-line no-new
firebase.initializeApp({
  apiKey: 'AIzaSyDG2xPrh11YI7Krp11vc2HeHs7YHPO9wRw',
  authDomain: 'thinkgas-390bf.firebaseapp.com',
  databaseURL: 'https://thinkgas-390bf.firebaseio.com',
  projectId: 'thinkgas-390bf',
  storageBucket: 'thinkgas-390bf.appspot.com',
  messagingSenderId: '363262839911',
  appId: '1:363262839911:web:b141652a0cbc4adddcd8c2',
  measurementId: 'G-JLK2E9FWB7'
})

Vue.use(msal, {
  auth: {
    clientId: '7663863f-523a-41e3-a21a-7a353aa939d4',
    tenantId: '1a63eded-aece-4b7f-a3d7-39828b274d9b',
    authority:
      'https://login.microsoftonline.com/1a63eded-aece-4b7f-a3d7-39828b274d9b/',
    redirectUri: 'https://journeymanagement.think-gas.com' // changed recerntly
  },
  cache: {
    cacheLocation: 'sessionStorage' // This configures where your cache will be stored
  },

  accessToken: ''
})

const vm = new Vue({
  el: '#root',
  router: router,
  store: store,
  render: h => h(AppView),
  created() {
    if (this.$msal.isAuthenticated()) {
      this.loading = true
      const payload = {
        email: this.$msal.data.user.userName,
        id: this.$msal.data.user.idTokenClaims.oid
      }
      authService
        .loginAzure(payload)
        .then(response => {
          this.loading = false
          this.$snotify.success('Login successful', 'Success!')
          this.$router.push('/')
        })
        .catch(error => {
          this.loading = false
          this.flash = true
          this.flashType = 'error'
          if (error.data.message === 'User is not active') {
            console.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>>', error.data.message)
            this.$snotify.error(
              'You are an Inactive User. Please contact your administrator'
            )
          }
          if (error.data.message === 'User does not exist in database.') {
            console.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>>', error.data.message)
            this.$snotify.error(
              'You are not a existing user in database. Please contact your administrator.'
            )
          }
        })
    }
  }
})

export default vm



// WEBPACK FOOTER //
// ./src/main.js